export function getContactsId(contact) {
  if (contact.channels && contact.channels.length > 0) {
    return contact.channels[0].id;
  }
  return contact.uniqueId;
}
